import { render, staticRenderFns } from "./CoLiving.vue?vue&type=template&id=3118c387&"
import script from "./CoLiving.vue?vue&type=script&lang=js&"
export * from "./CoLiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports